import { FileWithPath } from 'react-dropzone';

import { FormatTyp, TypInterwalu, RcpFiltr } from 'api/autoExport/autoExport.enum';
import { TreeSelectOption } from 'ui/organizationsTreeSelect/OrganizationsTreeSelect.types';

export const PASSWORD_PLACEHOLDER = '••••••••';

export type AutomationFormBody = {
  adres: string;
  port: string;
  nazwaUzytkownika: string;
  haslo: string;
  katalog: string;
  formatTyp: FormatTyp | '';
  nazwaPliku: string;
  typInterwalu: TypInterwalu | '';
  interwalMinuty: string;
  harmonogramCzas1: Date | null;
  harmonogramCzas2: Date | null;
  harmonogramCzas3: Date | null;
  stempelDaty: boolean;
  rcpFiltr: RcpFiltr;
  komorki: TreeSelectOption[];
};

export type AutomationProps = {
  onSubmit: (data: AutomationFormBody) => void;
  isLoading: boolean;
  isEditing: boolean;
  isActive: boolean;
  lastError: string | null;
  isConfigComplete: boolean;
  isLifecycleLoading: boolean;
  onStartExport: () => void;
  onStopExport: () => void;
  onEditClick: () => void;
  onCancelClick: () => void;
  privateKeyFile: FileWithPath | undefined;
  onPrivateKeyDrop: (files: FileWithPath[]) => void;
  onPrivateKeyRemove: () => void;
  privateKeyError: string | undefined;
  setPrivateKeyError: (error: string | undefined) => void;
  isValidatingFile: boolean;
  hasPassword: boolean;
  hasPrivateKey: boolean;
  /**
   * WKD-2441: true when the operator has edited address/port/username in the
   * current edit session. While true, the "(klucz przesłany)" indicator is
   * suppressed because the stored key will be cleared on save (unless a new
   * one is uploaded first).
   */
  keyDirty: boolean;
};
